import { useLocale } from "@/components/providers/i18n-provider";
import { checkUrl, crawlUrl } from "@/services";
import { hasProtocol } from "@/utils";
import { useQuery } from "@tanstack/react-query";

export const CHECK_URL_QUERY_KEY = "check-url";

export function useCheckUrl({
  url,
  enabled = false,
  byPassCrawl = false,
}: {
  url: string;
  enabled?: boolean;
  byPassCrawl?: boolean;
}) {
  const locale = useLocale();

  return useQuery({
    queryKey: [CHECK_URL_QUERY_KEY, url, locale],
    queryFn: async ({ signal }) => {
      if (byPassCrawl) return null;

      if (signal.aborted) throw new Error("Aborted");

      const dataCheckUrl = await checkUrl({
        url: !hasProtocol(url) ? `https://${url}` : url,
      });

      if (signal.aborted) throw new Error("Aborted");

      return dataCheckUrl;
    },
    // No auto-refetch on window focus or retry (we handle retries manually)
    retry: 0,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    staleTime: 0,
    gcTime: 0,
    enabled: !!url && enabled,
  });
}

async function waitWithAbort(ms: number, signal?: AbortSignal): Promise<void> {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => resolve(), ms);
    signal?.addEventListener("abort", () => {
      clearTimeout(timer);
      reject(new Error("Aborted"));
    });
  });
}
